export function normalizeTrackingUrls(value) {
  if (!value) return []

  let urls
  if (typeof value === 'string' && value.trimStart().startsWith('[')) {
    try {
      urls = JSON.parse(value)
    } catch {
      return []
    }
  } else {
    urls = [value]
  }

  return urls.filter(url => {
    try {
      const parsed = new URL(url)
      return parsed.protocol === 'http:' || parsed.protocol === 'https:'
    } catch {
      return false
    }
  })
}
